// extracted by mini-css-extract-plugin
module.exports = {"title":"title__1xrsI","form":"form__K6izq","textarea":"textarea__3GMyR","modal":"modal__1_aGL"};